<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header card-gis-filter">
        <el-collapse v-model="activeName" @change="handleCollapse">
          <el-collapse-item :title="titleFilter" name="1">
            <div class="row p-3">
              <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
                <label>{{ $t('common_words.farm') }} *</label>
                <br />
                <el-select
                  clearable
                  multiple
                  v-bind:collapse-tags="true"
                  filterable
                  @change="
                    selectAllFromSelect('productionSummaryForm.farm_ids', farms)
                  "
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="productionSummaryForm.farm_ids"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="(option, index) in farms"
                    class="select-primary selected-all"
                    :value="option.id"
                    :label="option.name"
                    :key="index + option.id"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                <label>{{ $t('common_words.analyze_by') }} </label>
                <br />
                <el-select
                  @change="changeByInterval"
                  filterable
                  @clear="productionSummaryForm.bySel = null"
                  clearable
                  class="select-primary custom-width-select required-farm shadow-sm"
                  size="large"
                  v-model="productionSummaryForm.bySel"
                  :placeholder="`${$t('common_words.select')}...`"
                >
                  <el-option
                    v-for="option in optionsInterval"
                    class="select-primary"
                    :value="option.value"
                    :label="option.label"
                    :key="option.value"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-12 col-sm-8 col-md-4 col-lg-4 col-xl-3"
                v-if="
                  productionSummaryForm.bySel != 'week' &&
                  productionSummaryForm.bySel != 'year'
                "
              >
                <label>{{ $t('common_words.calendar') }}</label>
                <br />
                <el-date-picker
                  v-if="renderComponent"
                  v-model="rangeDate"
                  class="shadow-sm required-year"
                  v-bind:type="typedatepicket"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  :placeholder="`${$t('common_words.select2')}...`"
                  :start-placeholder="$t('common_words.initial_date')"
                  :end-placeholder="$t('common_words.final_date')"
                >
                </el-date-picker>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-right: 0; padding-top: 32px"
                v-if="
                  productionSummaryForm.bySel == 'week' ||
                  productionSummaryForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-year shadow-sm"
                  size="large"
                  v-model="productionSummaryForm.year_sel_init"
                >
                  <el-option
                    v-for="(option, index) in years"
                    class="select-primary"
                    :value="option[0]"
                    :label="option[0]"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  productionSummaryForm.bySel == 'week' &&
                  productionSummaryForm.year_sel_init
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="productionSummaryForm.week_sel_init"
                >
                  <el-option
                    v-for="(week, index) in years.find(
                      (element) =>
                        element[0] == productionSummaryForm.year_sel_init
                    )[1]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  productionSummaryForm.bySel == 'week' ||
                  productionSummaryForm.bySel == 'year'
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="productionSummaryForm.year_sel_end"
                >
                  <el-option
                    v-for="(option, index) in years"
                    class="select-primary"
                    :value="option[0]"
                    :label="option[0]"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div
                class="col-6 col-sm-3 col-md-2 col-lg-2 col-xl-1"
                style="padding-top: 32px"
                v-if="
                  productionSummaryForm.bySel == 'week' &&
                  productionSummaryForm.year_sel_end
                "
              >
                <el-select
                  clearable
                  filterable
                  class="select-primary custom-width-select required-week shadow-sm"
                  size="large"
                  v-model="productionSummaryForm.week_sel_end"
                >
                  <el-option
                    v-for="(week, index) in years.find(
                      (element) =>
                        element[0] == productionSummaryForm.year_sel_end
                    )[1]"
                    class="select-primary"
                    :value="week"
                    :label="week"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
              <div class="col-12 col-md-4 col-xl-2">
                <label class="label-primary" style="color: transparent">{{
                  $t('common_words.filter')
                }}</label
                ><br />
                <l-button wide type="info" class="btn-filter" @click="validate">
                  {{ $t('common_words.filter') }}
                </l-button>
              </div>
            </div>
          </el-collapse-item>
        </el-collapse>
      </card>
      <br />
      <card
        class="custom-shadow-card-header custom-table-responsive"
        :title="$t('common_words.production_report')"
        v-if="productionSummary"
      >
        <div class="mt-4" v-if="isIndex()">
          <!-- <div class="custom-flex">
                      <el-select
                        clearable
                        @clear="pagination.perPage = 10"
                        class="select-default mb-3 shadow-sm"
                        style="width: 200px"
                        v-model="pagination.perPage"
                        placeholder="Por página"
                        filterable
                      >
                        <el-option
                          class="select-default"
                          v-for="item in pagination.perPageOptions"
                          :key="item"
                          :label="item"
                          :value="item"
                        ></el-option>
                      </el-select>
                      <el-input
                        clearable
                        class="mb-3 shadow-sm"
                        style="width: 200px"
                        placeholder="Buscar registros"
                        v-model="searchQuery"
                        aria-controls="datatables"
                      />
                    </div> -->

          <div style="overflow-x: scroll">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <td
                    style="
                      background-color: #888888;
                      color: white;
                      font-weight: bolder;
                      font-size: 14px;
                      width: 147.5px !important;
                    "
                    scope="col"
                    class="text-center"
                    rowspan="2"
                  >
                    {{ getLabelInterval }}
                  </td>
                  <td
                    style="
                      background-color: #888888;
                      color: white;
                      font-weight: bolder;
                      font-size: 14px;
                      width: 147.5px !important;
                    "
                    scope="col"
                    class="text-center"
                    rowspan="2"
                  >
                    {{ $t('common_words.farm') }}
                  </td>
                  <td
                    :colspan="bc[column.box_category_name]"
                    v-for="(column, index) in columns"
                    :key="index"
                    style="
                      background-color: #888888;
                      color: white;
                      font-weight: bolder;
                      font-size: 14px;
                      width: 147.5px !important;
                    "
                    scope="col"
                    class="text-center"
                  >
                    {{
                      column.box_category_name.charAt(0) +
                      column.box_category_name.slice(1).toLowerCase()
                    }}
                  </td>

                  <!-- <td
                              style="background-color:#888888;
                              color:white;
                              font-weight: bolder;
                              font-size: 14px;
                              width: 147.5px !important;"
                              scope="col" class="text-center"
                              rowspan="2"
                            >Peso Fruta Producción TOTAL (Kg)</td> -->

                  <!-- <td rowspan="2" style="background-color:#888888;
                              color:white;
                              font-weight: bolder;
                              font-size: 14px;"
                              scope="col" class="text-center">
                              Rac. Cortados
                            </td>
                            <td rowspan="2" style="background-color:#888888;
                              color:white;
                              font-weight: bolder;
                              font-size: 14px;"
                              scope="col" class="text-center"
                              >
                              Rac. Rechazados
                            </td>
                            <td
                            style="background-color:#888888;
                              color:white;
                              font-weight: bolder;
                              font-size: 14px;
                              min-width:100px !important;"
                              rowspan="2"
                              scope="col" class="text-center"
                              >
                              Peso Neto
                            </td> -->

                  <!-- <td style="background-color:#888888;
                              color:white;
                              font-weight: bolder;
                              font-size: 14px;"
                              rowspan="2"
                              scope="col" class="text-center"
                              >
                              Ratio
                            </td> -->

                  <!-- <td style="background-color:#888888;
                              color:white;
                              font-weight: bolder;
                              font-size: 14px;"
                              rowspan="2"
                              scope="col" class="text-center"
                              >
                              Merma Total (Kg)
                            </td> -->
                </tr>
                <tr>
                  <td
                    v-for="(box, j) in boxes"
                    :key="j"
                    style="
                      white-space: nowrap;
                      background-color: #888888;
                      color: white;
                      font-weight: bolder;
                      font-size: 14px;
                      width: 147.5px !important;
                    "
                    scope="col"
                    class="text-center"
                  >
                    {{ box.charAt(0) + box.slice(1).toLowerCase() }}
                  </td>
                </tr>
              </thead>
              <tbody>
                <template v-for="(date, j) in tableData2">
                  <tr
                    v-for="(farm, k) in tableData2[j]"
                    style="white-space: nowrap"
                    scope="col"
                    class="text-center"
                    :key="k + j"
                  >
                    <td rowspan="" :key="k + 'b'">{{ j }}</td>
                    <td :key="k + 'c'">{{ k }}</td>
                    <template v-for="(box, l) in boxes">
                      <td :key="l + 'G'" style="height: 46px">
                        {{ tableData2[j][k][box] }}
                      </td>
                    </template>

                    <!-- <td v-if="productionFruitWeight[j]">
                                  {{Math.round((productionFruitWeight[j][k] + Number.EPSILON) * 100) / 100}}
                                </td>
                                <td v-else>{{null}}</td> -->

                    <!-- <td v-if="clusterData[j]">
                                  {{clusterData[j][k]['cut_clusters']}}
                                </td>
                                <td v-else>{{null}}</td>

                                <td v-if="clusterData[j]">
                                  {{clusterData[j][k]['rejected_clusters']}}
                                </td>
                                <td v-else>{{null}}</td>

                                <td style="min-width:100px !important;" v-if="clusterData[j]">
                                  {{clusterData[j][k]['avg_net_weight']}}
                                </td>
                                <td v-else>{{null}}</td> -->

                    <!-- <td v-if="dataRatio[j]">
                                  {{dataRatio[j][k]}}
                                </td>
                                <td v-else>{{null}}</td> -->

                    <!-- <td v-if="mermaData[j]">
                                  {{Math.round((mermaData[j][k] + Number.EPSILON) * 100) / 100}}
                                </td>
                                <td v-else>{{null}}</td> -->
                  </tr>
                  <tr
                    style="white-space: nowrap"
                    scope="col"
                    class="text-center"
                    :key="j + 'p'"
                  >
                    <th colspan="2">
                      {{ $t('common_words.total_conventional') }}
                    </th>
                    <th
                      v-for="(caja, index) in boxes"
                      :key="index + 'tc'"
                      style="height: 46px"
                    >
                      {{ totalDataConvencional[j][caja] }}
                    </th>

                    <!-- <th v-if="productionFruitWeightDataTotalConvencional[j]">
                                  {{Math.round((productionFruitWeightDataTotalConvencional[j] + Number.EPSILON) * 100) / 100}}
                                </th>
                                <th v-else>
                                  {{null}}
                                </th> -->

                    <!-- <th v-if="totalDataClusterConvencional[j]" :key="j+'TDCCC'">
                                  {{totalDataClusterConvencional[j]['total_cut']}}
                                </th>
                                <th v-else :key="j+'TDCCCE'">{{null}}</th>

                                <th v-if="totalDataClusterConvencional[j]" :key="j+'TDCCR'">
                                  {{totalDataClusterConvencional[j]['total_rej']}}
                                </th>
                                <th v-else :key="j+'TDCCRE'">{{null}}</th>

                                <th style="min-width:100px !important;" v-if="totalDataClusterConvencional[j]" :key="j+'TDCCW'">
                                  {{totalDataClusterConvencional[j]['total_weight']}}
                                </th>
                                <th v-else :key="j+'TDCCWE'">{{null}}</th>  -->

                    <!-- <th v-if="totalDataRatioConvencional[j]" :key="j+'TDRC'">
                                  {{totalDataRatioConvencional[j]}}
                                </th>
                                <th v-else :key="j+'TDRCE'">{{null}}</th> -->

                    <!-- <th v-if="mermaTotalDataConvencional[j]" :key="j+'MTDC'">{{Math.round((mermaTotalDataConvencional[j] + Number.EPSILON) * 100)/ 100}}</th>
                                <th v-else :key="j+'MTDCE'">{{null}}</th> -->
                  </tr>
                  <tr
                    style="white-space: nowrap"
                    scope="col"
                    class="text-center"
                    :key="j + 'oiu'"
                  >
                    <th colspan="2">{{ $t('common_words.total_organic') }}</th>
                    <th
                      v-for="(caja, index) in boxes"
                      :key="index + 'to'"
                      style="height: 46px"
                    >
                      {{ totalDataOrganica[j][caja] }}
                    </th>

                    <!-- <th v-if="productionFruitWeightDataTotalOrganica[j]">
                                  {{Math.round((productionFruitWeightDataTotalOrganica[j]+ Number.EPSILON) * 100)/ 100}}
                                </th>
                                <th v-else>{{null}}</th> -->

                    <!-- <th v-if="totalDataClusterOrganica[j]" :key="j+'TDCOC'">
                                  {{totalDataClusterOrganica[j]['total_cut']}}
                                </th>
                                <th v-else :key="j+'TDCCCE'">{{null}}</th>

                                <th v-if="totalDataClusterOrganica[j]" :key="j+'TDCOR'">
                                  {{totalDataClusterOrganica[j]['total_rej']}}
                                </th>
                                <th v-else :key="j+'TDCCRE'">{{null}}</th>

                                <th style="min-width:100px !important;" v-if="totalDataClusterOrganica[j]" :key="j+'TDCOW'">
                                  {{totalDataClusterOrganica[j]['total_weight']}}
                                </th>
                                <th v-else :key="j+'TDCCWE'">{{null}}</th> -->

                    <!-- <th v-if="totalDataRatioOrganica[j]" :key="j+'TDRO'">
                                  {{totalDataRatioOrganica[j]}}
                                </th>
                                <th v-else :key="j+'TDROE'">{{null}}</th> -->

                    <!-- <th v-if="mermaTotalDataOrganica[j]">{{Math.round((mermaTotalDataOrganica[j]+ Number.EPSILON) * 100)/ 100}}</th>
                                <th v-else :key="j+'MTDOE'">{{null}}</th> -->
                  </tr>

                  <tr
                    style="white-space: nowrap"
                    scope="col"
                    class="text-center"
                    :key="j + 'oyt'"
                  >
                    <th colspan="2">{{ $t('common_words.total') }}</th>
                    <th
                      v-for="(caja, index) in boxes"
                      :key="index + 'to'"
                      style="height: 46px"
                    >
                      {{ totalDate[j][caja] }}
                    </th>

                    <!-- <th v-if="productionFruitWeightDataTotalTotal[j]">
                                  {{Math.round((productionFruitWeightDataTotalTotal[j]+ Number.EPSILON) * 100)/ 100}}
                                </th> -->

                    <!-- <th v-if="totalDataClusterTotal[j]" :key="j+'TDCTC'">
                                  {{totalDataClusterTotal[j]['total_cut']}}
                                </th>
                                <th v-else :key="j+'TDCTCEC'">{{null}}</th>

                                <th v-if="totalDataClusterTotal[j]" :key="j+'TDCTR'">
                                  {{totalDataClusterTotal[j]['total_rej']}}
                                </th>
                                <th v-else :key="j+'TDCTRER'">{{null}}</th>

                                <th style="min-width:100px !important;" v-if="totalDataClusterTotal[j]" :key="j+'TDCTW'">
                                  {{totalDataClusterTotal[j]['total_weight']}}
                                </th>
                                <th v-else :key="j+'TDCTWEW'">{{null}}</th> -->

                    <!-- <th v-if="totalDataRatioTotal[j]" :key="j+'TDRT'">
                                  {{totalDataRatioTotal[j]}}
                                </th>
                                <th v-else :key="j+'TDRTE'">{{null}}</th> -->

                    <!-- <th v-if="mermaTotalDataTotal[j]">
                                  {{Math.round((mermaTotalDataTotal[j]+ Number.EPSILON) * 100)/ 100}}
                                </th>
                                <th v-else>{{null}}</th> -->
                  </tr>
                </template>

                <tr>
                  <th colspan="2">
                    {{ $t('common_words.total_conventional') }}
                  </th>
                  <template v-for="(caja, index) in boxes">
                    <th :key="index + caja + 'c'" class="text-center">
                      {{ boxesTotales[index]['totalConvencional'] }}
                    </th>
                  </template>

                  <!-- <th class="text-center">{{Math.round((productionFruitWeightDataTotalConvencionalGeneral+ Number.EPSILON) * 100)/ 100}}</th> -->

                  <!-- <th class="text-center">
                                  {{totalDataClusterTotalGeneralConvencional['total_cut']}}
                                </th>

                                <th class="text-center">
                                  {{totalDataClusterTotalGeneralConvencional['total_rej']}}
                                </th>

                                <th style="min-width:100px !important;" class="text-center">
                                  {{totalDataClusterTotalGeneralConvencional['total_weight']}}
                                </th> -->

                  <!-- <th class="text-center">
                                  {{Math.round((totalDataRatioGeneralConvencional+ Number.EPSILON) * 100)/ 100}}
                                </th> -->

                  <!-- <th class="text-center">{{Math.round((mermaGeneralConvencional+ Number.EPSILON) * 100)/ 100}}</th> -->
                </tr>

                <!-- </template> -->
                <tr>
                  <th colspan="2">{{ $t('common_words.total_organic') }}</th>
                  <template v-for="(caja, index) in boxes">
                    <th :key="index + caja + 'o'" class="text-center">
                      {{ boxesTotales[index]['totalOrganica'] }}
                    </th>
                  </template>
                  <!-- <th class="text-center">{{Math.round((productionFruitWeightDataTotalOrganicaGeneral+ Number.EPSILON) * 100)/ 100}}</th> -->

                  <!-- <th class="text-center">
                                  {{totalDataClusterTotalGeneralOrganica['total_cut']}}
                                </th>

                                <th class="text-center">
                                  {{totalDataClusterTotalGeneralOrganica['total_rej']}}
                                </th>

                                <th style="min-width:150px !important;" class="text-center">
                                  {{totalDataClusterTotalGeneralOrganica['total_weight']}}
                                </th> -->

                  <!-- <th class="text-center">
                                  {{Math.round((totalDataRatioGeneralOrganica+ Number.EPSILON) * 100)/ 100}}
                                </th> -->

                  <!-- <th class="text-center">{{Math.round((mermaGeneralOrganica+ Number.EPSILON) * 100)/ 100}}</th> -->
                </tr>

                <tr>
                  <th colspan="2">{{ $t('common_words.total') }}</th>
                  <template v-for="(caja, index) in boxes">
                    <th :key="index + caja + 'r'" class="text-center">
                      {{ boxesTotales[index]['total'] }}
                    </th>
                  </template>

                  <!-- <th class="text-center">{{Math.round((productionFruitWeightDataTotalTotalGeneral+ Number.EPSILON) * 100)/ 100}}</th> -->

                  <!-- <th class="text-center">
                                  {{totalDataClusterTotalGeneralTotal['total_cut']}}
                              </th>
                              <th class="text-center">
                                  {{totalDataClusterTotalGeneralTotal['total_rej']}}
                              </th>
                              <th style="min-width:100px !important;" class="text-center">
                                  {{totalDataClusterTotalGeneralTotal['total_weight']}}
                              </th> -->

                  <!-- <th class="text-center">
                                {{Math.round((totalDataRatioGeneralTotal+ Number.EPSILON) * 100)/ 100}}
                              </th> -->

                  <!-- <th class="text-center">{{Math.round((mermaGeneralTotal+ Number.EPSILON) * 100)/ 100}}</th> -->
                </tr>
              </tbody>
            </table>
          </div>
          <div class="row">
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
            >
              <div class>
                <p class="card-category">
                  {{ $t('table2.showing') }} {{ from + 1 }}
                  {{ $t('table2.a') }} {{ to }} {{ $t('table2.of') }}
                  {{ total }} {{ $t('table2.entries') }}
                </p>
              </div>
              <l-pagination
                class="pagination-no-border"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="pagination.total"
                pageFirst="false"
                pageLast="false"
              ></l-pagination>
            </div>
          </div>
        </div>
        <div class="row" style="padding-right: 13px; padding-left: 13px">
          <!-- <div class="col-6" v-if="isPDF()">
                    <div class="text-right">
                      <button class="btn btn-danger custom-shadow-btn" @click="exportToPDF">
                        <em class="fa fa-file-pdf-o"></em>
                        Exportar a PDF
                      </button>
                    </div>
                  </div> -->
          <div class="col-12" v-if="isExcel()">
            <div class="text-center">
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="exportExcel"
              >
                <em class="fa fa-file-excel-o"></em>
                {{ $t('common_words.export_to_excel') }}
              </button>
            </div>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import { mapActions } from 'vuex';
import SweetAlert from 'src/class/Alerts';
import paginationData from './paginationData';
import mixinMasters from 'src/util/mixinMasters';
import MixinDatePicker from 'src/util/mixinDatePicker';
import MixinPermissions from 'src/util/mixinPermissions';
import { MixinExport } from 'src/mixins/mixin-export';
import { Pagination as LPagination } from 'src/components/index';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...paginationData.functions,

    optionsInterval() {
      return {
        0: { label: i18n.t('common_words.day'), value: 'daterange' },
        1: { label: i18n.t('common_words.week'), value: 'week' },
        2: { label: i18n.t('common_words.month'), value: 'monthrange' },
        3: { label: i18n.t('common_words.year'), value: 'year' },
      };
    },
    getLabelInterval() {
      try {
        return Object.values(this.optionsInterval).find(
          (option) => option.value === this.productionSummaryForm.bySel
        ).label;
      } catch (error) {
        return 'Intervalo';
      }
    },
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      productionSummaryForm: {
        bySel: null,
        year_sel_init: null,
        week_sel_init: null,
        year_sel_end: null,
        week_sel_end: null,
        farm_ids: [],
      },
      activeName: '1',
      bc: [],
      totalDataConvencional: [],
      totalDataOrganica: [],
      clusterData: [],
      dataRatio: [],
      totalDataClusterConvencional: [],
      totalDataClusterOrganica: [],
      totalDataClusterTotal: [],
      totalDataClusterTotalGeneralConvencional: null,
      totalDataClusterTotalGeneralOrganica: null,
      totalDataClusterTotalGeneralTotal: null,
      totalDataRatioConvencional: [],
      totalDataRatioOrganica: [],
      totalDataRatioTotal: [],
      totalDataRatioGeneralConvencional: null,
      totalDataRatioGeneralOrganica: null,
      totalDataRatioGeneralTotal: null,
      productionFruitWeight: [],
      productionFruitWeightDataTotalConvencional: [],
      productionFruitWeightDataTotalOrganica: [],
      productionFruitWeightDataTotalTotal: [],
      productionFruitWeightDataTotalConvencionalGeneral: null,
      productionFruitWeightDataTotalOrganicaGeneral: null,
      productionFruitWeightDataTotalTotalGeneral: null,
      mermaTotalDataConvencional: [],
      mermaTotalDataOrganica: [],
      mermaTotalDataTotal: [],
      mermaGeneralConvencional: null,
      mermaGeneralOrganica: null,
      mermaGeneralTotal: null,
      totalDate: [],
      mermaData: [],
      totalGeneral: [],
      boxesTotales: [],
      typedatepicket: 'daterange',
      totalGeneralCRW: null,
      searchQuery: '',
      fuseSearch: null,
      columns: [],
      tableData: [],
      years: [],
      farms: [],
      nColumns: 0,
      productionSummary: false,
      pagination: paginationData.pagination,
      valueCollapse: null,
    };
  },

  mixins: [
    MixinPermissions,
    MixinDatePicker,
    mixinMasters,
    MixinExport,
    MixinMenu,
  ],
  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },

    ...mapActions({
      validationInputsRequired: 'utils/validationInputsRequired',
    }),

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    changeByInterval() {
      this.productionSummary = false;
      this.typedatepicket = this.avancedReportForm.bySel;
    },

    validate() {
      if (
        this.productionSummaryForm.farm_ids == null ||
        this.productionSummaryForm.farm_ids.length == 0
      ) {
        return this.validationInputsRequired('farm');
      } else if (
        (this.productionSummaryForm.bySel == 'year' &&
          (this.productionSummaryForm.year_sel_init == null ||
            this.productionSummaryForm.year_sel_end == null)) ||
        (this.productionSummaryForm.bySel == 'week' &&
          this.isYearSelRequired() &&
          this.productionSummaryForm.year_sel_init == null)
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.productionSummaryForm.week_sel_init == null &&
        this.productionSummaryForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
      } else if (
        this.isYearSelRequired() &&
        this.productionSummaryForm.year_sel_end == null &&
        this.productionSummaryForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('year');
      } else if (
        this.isWeekSekRequired() &&
        this.productionSummaryForm.week_sel_end == null &&
        this.productionSummaryForm.bySel == 'week'
      ) {
        return this.validationInputsRequired('week');
        // } else if (this.productionSummaryForm.calendar_sel == null) {
        //   SweetAlert.warning('No tienes asociado un calendario.')
      } else if (this.rangeDate == null) {
        return this.validationInputsRequired('year');
      } else {
        this.loadProductionSummaryReport();
      }
    },

    isYearSelRequired() {
      return this.interval == 'week';
    },

    isWeekSekRequired() {
      return this.interval == 'week';
    },

    loadData() {
      let data = {
        farms: this.productionSummaryForm.farm_ids,
        init: null,
        end: null,
        bySel: this.productionSummaryForm.bySel,
      };

      switch (this.productionSummaryForm.bySel) {
        case 'year':
          data.init = this.productionSummaryForm.year_sel_init;
          data.end = this.productionSummaryForm.year_sel_end;
          break;
        case 'monthrange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
        case 'week':
          data.init = `${this.productionSummaryForm.year_sel_init}-${(
            '0' + this.productionSummaryForm.week_sel_init
          ).slice(-2)}`;
          data.end = `${this.productionSummaryForm.year_sel_end}-${(
            '0' + this.productionSummaryForm.week_sel_end
          ).slice(-2)}`;
          break;
        case 'daterange':
          data.init = moment(this.rangeDate[0]).format('YYYY-MM-DD');
          data.end = moment(this.rangeDate[1]).format('YYYY-MM-DD');
          break;
      }

      return data;
    },

    loadProductionSummaryReport() {
      this.columns = [];
      this.boxesTotales = [];
      this.productionSummary = false;
      this.boxes = [];
      this.totalDataConvencional = [];
      this.totalDataOrganica = [];
      this.totalDate = [];
      this.tableData2 = [];

      this.showHideLoading(true);
      let data = this.loadData();
      data.route = 'summary/productionsummary';

      Axios.postMasters(data)
        .then((response) => {
          if (response.data.data) {
            this.columns = response.data.data.columns;
            this.boxesTotales = response.data.data.boxesTotales;
            this.productionSummary = true;
            this.boxes = response.data.data.boxes;
            this.totalDataConvencional =
              response.data.data.totalDataConvencional;
            this.totalDataOrganica = response.data.data.totalDataOrganica;
            this.totalDate = response.data.data.totalDate;
            this.tableData2 = response.data.data.tableData2;
            this.clusterData = response.data.data.clusterData;
            this.totalDataClusterConvencional =
              response.data.data.totalDataClusterConvencional;
            this.totalDataClusterOrganica =
              response.data.data.totalDataClusterOrganica;
            this.totalDataClusterTotal =
              response.data.data.totalDataClusterTotal;
            this.totalDataClusterTotalGeneralConvencional =
              response.data.data.totalDataClusterTotalGeneralConvencional;
            this.totalDataClusterTotalGeneralOrganica =
              response.data.data.totalDataClusterTotalGeneralOrganica;
            this.totalDataClusterTotalGeneralTotal =
              response.data.data.totalDataClusterTotalGeneralTotal;
            this.dataRatio = response.data.data.dataRatio;
            this.totalDataRatioConvencional =
              response.data.data.totalDataRatioConvencional;
            this.totalDataRatioOrganica =
              response.data.data.totalDataRatioOrganica;
            this.totalDataRatioTotal = response.data.data.totalDataRatioTotal;
            this.totalDataRatioGeneralConvencional =
              response.data.data.totalDataRatioGeneralConvencional;
            this.totalDataRatioGeneralOrganica =
              response.data.data.totalDataRatioGeneralOrganica;
            this.totalDataRatioGeneralTotal =
              response.data.data.totalDataRatioGeneralTotal;
            this.productionFruitWeight =
              response.data.data.productionFruitWeight;
            this.productionFruitWeightDataTotalConvencional =
              response.data.data.productionFruitWeightDataTotalConvencional;
            this.productionFruitWeightDataTotalOrganica =
              response.data.data.productionFruitWeightDataTotalOrganica;
            this.productionFruitWeightDataTotalTotal =
              response.data.data.productionFruitWeightDataTotalTotal;
            this.mermaData = response.data.data.mermaData;
            this.mermaTotalDataConvencional =
              response.data.data.mermaTotalDataConvencional;
            this.mermaTotalDataOrganica =
              response.data.data.mermaTotalDataOrganica;
            this.mermaTotalDataTotal = response.data.data.mermaTotalDataTotal;
            this.productionFruitWeightDataTotalConvencionalGeneral =
              response.data.data.productionFruitWeightDataTotalConvencionalGeneral;
            this.productionFruitWeightDataTotalOrganicaGeneral =
              response.data.data.productionFruitWeightDataTotalOrganicaGeneral;
            this.productionFruitWeightDataTotalTotalGeneral =
              response.data.data.productionFruitWeightDataTotalTotalGeneral;
            this.mermaGeneralConvencional =
              response.data.data.mermaGeneralConvencional;
            this.mermaGeneralOrganica = response.data.data.mermaGeneralOrganica;
            this.mermaGeneralTotal = response.data.data.mermaGeneralTotal;
            this.bc = response.data.data.bc;
          } else {
            SweetAlert.warning(
              i18n.t('sweet_alert.production.no_data_farms_dates')
            );
          }

          this.showHideLoading();
        })
        .catch((error) => {
          console.log(error);
          this.showHideLoading();
        });
    },

    exportToPDF() {
      let data = this.loadData();
      data.route = 'summary/productionsummary/pdf';
      data.name_file = `${i18n.t('production.production_summary')}.pdf`;

      this.PDF(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },

    exportExcel() {
      let data = this.loadData();
      data.route = 'summary/productionsummary/excel';
      data.name_file = `${i18n.t('production.production_summary')}.xlsx`;

      this.Excel(data, 'POST', true)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    },
  },

  created() {
    if (this.isIndex()) {
      this.showHideLoading(true);
      Axios.getMasters('farms/farms/onlyfruit')
        .then((response) => {
          this.farms = this.concatAll(response.data.data);
          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }

    Axios.getMasters('calendars/getyearsbusiness').then((response) => {
      let yearsArray = Object.keys(response.data)
        .map((key) => [key, response.data[key]])
        .reverse();
      this.years = yearsArray;

      this.showHideLoading();
    });

    let current = new Date();
    this.rangeDate = [
      new Date(current.setDate(current.getDate() - current.getDay())),
      new Date(current.setDate(current.getDate() - current.getDay() + 6)),
    ];
  },

  mounted() {
    this.selectedItemOnMenu('summary');
  },

  beforeDestroy() {
    this.deselectedItemOnMenu('summary');
  },
};
</script>

<style scoped></style>
